import { Redirect, Route } from 'react-router-dom';
import React from 'react';
import { useSelector } from 'react-redux';
import { getIsOrganizationUser } from '../features/basic/reducers/basicReducer';
import styled from "styled-components";
import { useTheme } from '../features/context/CustomerContext';
import useCustomTranslation from '../features/hooks/CustomUseTranslation';

const Container = styled.div`
    @media screen and (max-width: ${props => props.theme.mobileTableBreakPoint}px) {
        margin: 0; 
    }
    margin: 0 60px 60px 60px;  
    background: white;
    height: 500px;
    border-bottom-right-radius: 10px;
    border-bottom-left-radius: 10px;
    display: flex;
    padding: 40px;
`

interface PrivateRouteProps extends React.PropsWithChildren<{}> {
    path: string;
}

export const PrivateRoute= (props: PrivateRouteProps) => {
    const isOrganizationUser= useSelector(getIsOrganizationUser);
    const { t } = useCustomTranslation();
    const theme = useTheme();

    const isAuthorized = () => {
       
        if(props.path === "/organizations") {
            return isOrganizationUser;
        }
        else if(props.path !== '/organizations') {
            return true;
        }
        return false;
    }

    if(!isAuthorized() && props.path === "/sentApplications"){
        return <Container theme={theme}>{t("Unauthorized")}</Container>
    }

    return (
        <Route 
            path={ props.path }
            render={p => {
                return isAuthorized()
                    ? props.children 
                    : <Redirect to={{ pathname: '/',}} />
            }}
        />
    )
}
